import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { OrganizationModel, OrganizationInterface } from '@app/shared/models/organization.model';
import { map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { AppConstant } from '@app/app.constant';
import { ApiOptionInterface } from '@core/models/api-option.interface';

@Injectable({
    providedIn: 'root'
})
export class OrganizationApiService {
    static ORGANIZATION = 'organizations';
    static VERIFY_INVITE_TOKEN = 'organizations/verify';
    static ORGANIZATION_SETTINGS = 'organizations/settings';
    static SUMMARY = 'organizations/summary';
    static ORGANIZATION_MODULE = 'organizations/module/with-action';
    static ORGANIZATION_USERS = 'organizations/user';
    static INVITE_ORGANIZATION_USER = 'organizations/user/invite';
    static CREATE_BUSINESS_UNIT = 'organizations/business-unit';
    static GET_ALL_BUSINESS_UNIT = 'organizations/business-unit';
    static GROUP_LIST_ORGANIZATION = 'organizations/group';
    static GET_DETAIL_BUSINESS_UNIT = 'organizations/business-unit';
    static GET_USERS_OF_BUSINESS_UNIT =        'organizations/business-unit/:businessUnitId/users';
    static REGISTER = 'organizations/register';
    static ZOOM_VERIFY = 'video-call/zoom/verify';

    constructor(private apiService: ApiService) { }

    verifyInviteToken(token) {
        return this.apiService.post(
            OrganizationApiService.VERIFY_INVITE_TOKEN,
            token
        );
    }

    getDetail(): Observable<OrganizationModel> {
        return this.apiService
            .get(OrganizationApiService.ORGANIZATION, {}, {
                exposeHeaders: {
                    [AppConstant.HTTP_ERROR.HTTP_STATUS_CODE_EXCLUDE]: ['403']
                }
            })
            .pipe(map(data => OrganizationModel.fromJson(data)));
    }

    update(data): Observable<OrganizationModel> {
        return this.apiService.patch(OrganizationApiService.ORGANIZATION, data).pipe(map(res => OrganizationModel.fromJson(res)));
    }

    getSummary() {
        return this.apiService.get(OrganizationApiService.SUMMARY);
    }

    getOrganizationModules() {
        return this.apiService.post(OrganizationApiService.ORGANIZATION_MODULE);
    }

    getOrganizationUsers(query) {
        return this.apiService.get(
            OrganizationApiService.ORGANIZATION_USERS,
            query
        );
    }

    inviteOrganizationUser(data) {
        return this.apiService.post(
            OrganizationApiService.INVITE_ORGANIZATION_USER,
            data
        );
    }

    createBusinessUnit(data) {
        return this.apiService.post(
            OrganizationApiService.CREATE_BUSINESS_UNIT,
            data
        );
    }

    updateOrganizationSettings(data) {
        return this.apiService.post(
            OrganizationApiService.ORGANIZATION_SETTINGS,
            data
        );
    }

    getAllBusinessUnit() {
        return this.apiService.get(
            OrganizationApiService.GET_ALL_BUSINESS_UNIT
        );
    }

    getOrganizationGroups() {
        return this.apiService.get(
            OrganizationApiService.GROUP_LIST_ORGANIZATION
        );
    }

    getBusinessUnitDetail(businessUnitId) {
        return this.apiService.get(
            OrganizationApiService.GET_DETAIL_BUSINESS_UNIT +
            '/' +
            businessUnitId
        );
    }

    updateBusinessUnit(businessUnitId, data) {
        return this.apiService.put(
            OrganizationApiService.CREATE_BUSINESS_UNIT + '/' + businessUnitId,
            data
        );
    }

    getUsersOfBusinessUnit(businessUnitId, query) {
        query.businessUnitId = businessUnitId;
        return this.apiService.get(
            OrganizationApiService.GET_USERS_OF_BUSINESS_UNIT,
            query
        );
    }
    register(data): Observable<OrganizationModel> {
        return this.apiService.post(OrganizationApiService.REGISTER, data).pipe(
            map(
                (res: OrganizationInterface) => OrganizationModel.fromJson(res)
            ));
    }

    zoomVerify(data: {zoomApiKey: string; zoomSecretKey}) {
        return this.apiService.post(OrganizationApiService.ZOOM_VERIFY, data);
    }
}
